import Navbar from "../components/Navbar";
import HeaderInner from "../components/HeaderInner";
import BlogSection from "../components/BlogSection";

function Blog() {
  return (
    <div>
      <Navbar />
      <HeaderInner title="Our Blog" /> {/* ✅ Pass a title if HeaderInner is reusable */}
      <BlogSection />
    </div>
  );
}

export default Blog;
